export default "__VITE_ASSET__36b736d1__"